/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ScheduledProposalDate from './ScheduledProposalDate';

/**
 * The ScheduledProposalDatesResponse model module.
 * @module model/ScheduledProposalDatesResponse
 * @version 1.0.0
 */
class ScheduledProposalDatesResponse {
    /**
     * Constructs a new <code>ScheduledProposalDatesResponse</code>.
     * @alias module:model/ScheduledProposalDatesResponse
     */
    constructor() { 
        
        ScheduledProposalDatesResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ScheduledProposalDatesResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ScheduledProposalDatesResponse} obj Optional instance to populate.
     * @return {module:model/ScheduledProposalDatesResponse} The populated <code>ScheduledProposalDatesResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ScheduledProposalDatesResponse();

            if (data.hasOwnProperty('scheduled_dates')) {
                obj['scheduled_dates'] = ApiClient.convertToType(data['scheduled_dates'], [ScheduledProposalDate]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ScheduledProposalDatesResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ScheduledProposalDatesResponse</code>.
     */
    static validateJSON(data) {
        if (data['scheduled_dates']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['scheduled_dates'])) {
                throw new Error("Expected the field `scheduled_dates` to be an array in the JSON data but got " + data['scheduled_dates']);
            }
            // validate the optional field `scheduled_dates` (array)
            for (const item of data['scheduled_dates']) {
                ScheduledProposalDate.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Array.<module:model/ScheduledProposalDate>} scheduled_dates
 */
ScheduledProposalDatesResponse.prototype['scheduled_dates'] = undefined;






export default ScheduledProposalDatesResponse;

